import { Link, useLocation } from "react-router"
import styles from "./admin-sidebar.module.css"

interface MenuItem {
  path: string
  label: string
  icon: string
  badge?: string
  dot?: boolean
}

interface NavGroup {
  title: string
  items: MenuItem[]
}

const navigationGroups: NavGroup[] = [
  {
    title: "概览",
    items: [{ path: "/admin/dashboard", label: "数据总览", icon: "📊" }],
  },
  {
    title: "运营管理",
    items: [
      { path: "/admin/users", label: "用户管理", icon: "👥", dot: true },
      { path: "/admin/tasks", label: "任务管理", icon: "📋", dot: true },
      { path: "/admin/finance", label: "财务管理", icon: "💰" },
    ],
  },
  {
    title: "内容管理",
    items: [
      { path: "/admin/courses", label: "课程管理", icon: "🎓" },
      { path: "/admin/hackathons", label: "黑客松", icon: "🏆" },
      { path: "/admin/community", label: "社区管理", icon: "🌐", badge: "99+", dot: true },
    ],
  },
  {
    title: "系统",
    items: [
      { path: "/admin/logs", label: "操作日志", icon: "📜" },
      { path: "/admin/settings", label: "系统设置", icon: "⚙️" },
    ],
  },
]

export function AdminSidebar() {
  const location = useLocation()

  return (
    <aside className={styles.sidebar}>
      <div className={styles.logo}>
        <span className={styles.logoIcon}>🔵</span>
        <span className={styles.logoText}>蓝血精英</span>
      </div>
      <nav className={styles.nav}>
        {navigationGroups.map((group) => (
          <div key={group.title} className={styles.navGroup}>
            <div className={styles.groupTitle}>{group.title}</div>
            {group.items.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`${styles.menuItem} ${location.pathname === item.path ? styles.active : ""}`}
              >
                <span className={styles.icon}>{item.icon}</span>
                <span className={styles.label}>{item.label}</span>
                {item.badge && <span className={styles.badge}>{item.badge}</span>}
                {item.dot && <span className={styles.dot} />}
              </Link>
            ))}
          </div>
        ))}
      </nav>
    </aside>
  )
}